import {AssistantEvenCompactModel} from "../assistants";
import {ListModel} from "../common";
import {ActionTypeModel} from "./main";

import {TransferCallActionCallTransferInfoVoicemailDetection} from "@/api/services";
import {EditCallTransferSchemaFormData} from "@/utils/callTransfer/schema";
import {BaseAction} from "@/types/api";
import {ActionNodeData} from "@/types/node";

export enum TransferCallActionBackgroundMusicTypeModel {
  ROCK = "rock",
  JAZZ = "jazz",
  CLASSIC = "classic",
}

export enum TransferCallActionStatusModel {
  ACTIVE = "active",
  PAUSED = "paused",
}

export enum TransferCallActionHumanAvailabilityScheduleItemWeekdayModel {
  MON = "Mon",
  TUE = "Tue",
  WED = "Wed",
  THU = "Thu",
  FRI = "Fri",
  SAT = "Sat",
  SUN = "Sun",
}

export enum TransferCallActionWarmCallTransferVoicemailDetectionModel {
  ML_BASED = "Ml-Based",
  TIME_BASED = "Time-Based",
}

export enum TransferCallActionWarmCallTransferMode {
  WARM_TRANSFER_WITH_MESSAGE = "warm_transfer",
  WARM_TRANSFER_WITH_CONTEXTUAL_SUMMARY = "warm_transfer_with_context",
  BLIND_TRANSFER = "cold_transfer",
}

export interface TransferCallActionBackgroundMusicModel {
  type?: TransferCallActionBackgroundMusicTypeModel;
  url?: string;
  message?: string;
  active?: boolean;
}

export type TransferCallActionAdvancedModel = {
  extension?: string;
  timeout?: number;
  tryingMessage?: string;
  answeredMessage?: string;
  noAnswerMessage?: string;
};

export type WeekDays =
  | "monday"
  | "tuesday"
  | "wednesday"
  | "thursday"
  | "friday"
  | "saturday"
  | "sunday";

export type DayAvailabilityModel = {
  start?: string;
  end?: string;
  isAvailable?: boolean;
};

export type AvailabilityModel = Partial<Record<WeekDays, DayAvailabilityModel>>;

export type TransferCallActionWarmCallTransferModel = {
  voicemailDetection?: TransferCallActionCallTransferInfoVoicemailDetection;
  language?: string;
  message?: string;
  preMessagePause?: number;
  postMessagePause?: number;
  mode?: TransferCallActionWarmCallTransferMode;
};

export enum CallTransferModeModel {
  SINGLE_NUMBER = "single_target",
  PHONE_BOOK = "phone_book",
}

export interface CallTransferRecordModel extends BaseAction {
  mode?: CallTransferModeModel; // TODO: must be synced with BE, currently it's only in FE
  title: string;
  description: string;
  transferToPhone: string;
  conditionTrigger: string;
  name: string;
  type: ActionTypeModel;
  workspaceId: string;
  phoneBookId?: string;
  status?: TransferCallActionStatusModel;
  phoneNumber?: string;
  backgroundMusic?: TransferCallActionBackgroundMusicModel;
  advanced?: TransferCallActionAdvancedModel;
  isHumanAvailableEnabled?: boolean;
  humanNotAvailableMessage?: string;
  availability?: AvailabilityModel;
  timezone?: string;
  callTransferInfo?: TransferCallActionWarmCallTransferModel;
  assistants: AssistantEvenCompactModel[];
  transferTargetType?: CallTransferModeModel;
  nodeData?: ActionNodeData;
}

export type CallTransferListModel = ListModel<CallTransferRecordModel>;

export type BackgroundMusicModel = {
  name: string;
  url: string;
  value: string;
};

export type BackgroundMusicListModel = BackgroundMusicModel[];

export interface CallTransferCreateModel
  extends Omit<EditCallTransferSchemaFormData, "mode"> {
  workspaceId: string;
}

export type CallTransferUpdateModel = CallTransferCreateModel & {
  id: string;
};
